/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type InternalGetIterationExposuresPathParams = NonNullable<
  operations['internalGetIterationExposures']['parameters']['path']
>;

export type InternalGetIterationExposuresQueryParams = NonNullable<
  operations['internalGetIterationExposures']['parameters']['query']
>;

export interface Input extends InternalGetIterationExposuresPathParams {
  apiVersion?: string;
  query: InternalGetIterationExposuresQueryParams;
  header: NonNullable<operations['internalGetIterationExposures']['parameters']['header']>;
}

export async function internalGetIterationExposures(
  { apiVersion, query, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET(
    '/internal/projects/{projectKey}/environments/{environmentKey}/experiments/{experimentKey}/iterations/{iterationId}/exposures',
    {
      params: { path, query, header },
      headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
      signal,
    },
  );
}
